
































import { Vue, Component } from "vue-property-decorator"
import api from "../honcierge-api"

@Component
export default class Bookcover extends Vue {
  private refetchSuccess = false
  private bookTitle = ""
  private bookCoverImageUrl = ""
  private isbn = ""
  private isFormValid = true
  private rules = [
    (value: string) => !!value || "入力されていません",
    (value: string) => this.checkString(value),
    (value: string) => this.isbnRules(value),
  ]
  private checkString(value: string): boolean | string {
    return /^[0-9a-zA-Z]+$/.test(value) || "半角英数字で入力してください"
  }
  private isbnRules(value: string): boolean | string {
    return (
      value.length === 10 ||
      value.length === 13 ||
      "ISBNを10桁または13桁で入力してください"
    )
  }
  private putRefetchBookCover() {
    api.putRefetchBookCover(this.isbn).then((res) => {
      if (res.data) {
        this.refetchSuccess = true
        this.bookTitle = res.data.title
        this.bookCoverImageUrl = res.data.cover_image_url
        this.$toasted.success("再取得に成功しました")
      } else {
        this.refetchSuccess = false
        this.$toasted.error("入力内容に誤りがあります")
      }
    })
  }
}
